import React from "react";
import { Form, Rate } from "antd";

const FormRating = ({
  label,
  name,
  rules,
  allowHalf = false,
  ...rest
}) => {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      valuePropName="value"
      {...rest}
      className="custom-rate"
    >
      <Rate allowHalf={allowHalf} />
    </Form.Item>
  );
};

export default FormRating;
